module.exports = __webpack_public_path__ + "static/img/PlusIcon.08b45dd5.svg";